// Galeria de trofeus e historico da carreira.
//
// Os trofeus que voce ainda nao ganhou aparecem APAGADOS, nao escondidos: uma
// galeria vazia nao diz nada, e uma galeria com as vagas a vista diz o que
// falta. E a mesma ideia da sala de trofeus do 38 Brasil.

import React from 'react';
import { CompartilharTemporada } from './compartilhar.jsx';
import { Trophy, Crest } from './crest.jsx';
import { Flag } from './flags.jsx';
import { AWARD_ORDER } from '../engine/awards.js';
import { userTeam, configOf } from '../engine/career.js';
import { teamById } from '../engine/career.js';

const TROPHIES = [
  { id: 'liga', name: 'Campeao da liga', hint: 'Vencer a final' },
  { id: 'conferencia', name: 'Campeao de conferencia', hint: 'Chegar a final' },
  { id: 'playoffs', name: 'Classificado', hint: 'Entrar nos playoffs' },
  { id: 'campanha', name: 'Melhor campanha', hint: 'Terminar a fase regular em primeiro' },
];

export function Gallery({ state }) {
  const team = userTeam(state);
  const config = configOf(state);
  const history = state.history || [];
  const counts = {};
  for (const h of history) {
    /* `trophies` e a lista completa; `trophy` sozinho e o formato antigo, que
       ainda existe em quem ja tem carreira salva. Ler os dois evita zerar a
       sala de quem estava jogando. */
    const ganhos = Array.isArray(h.trophies) && h.trophies.length
      ? h.trophies
      : (h.trophy ? [h.trophy] : []);
    for (const t of ganhos) counts[t] = (counts[t] || 0) + 1;
  }

  const titles = counts.liga || 0;
  const seasons = history.length;
  const totalWins = history.reduce((a, h) => a + (h.userRecord?.wins || 0), 0);
  const totalLosses = history.reduce((a, h) => a + (h.userRecord?.losses || 0), 0);

  return (
    <>
      <div className="card">
        <div className="row" style={{ gap: 12 }}>
          <Crest team={team} size={46} />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 800, fontSize: 17, letterSpacing: '-.02em' }}>{team.name}</div>
            <div className="small dim">
              <Flag code={config.flagCode} size={13} /> {config.name} · {state.coachName} · temporada {state.season}
            </div>
          </div>
        </div>
      </div>

      <div className="grid auto">
        <div className="stat"><div className="k">Titulos</div><div className="v gold">{titles}</div></div>
        <div className="stat"><div className="k">Temporadas</div><div className="v">{seasons}</div></div>
        <div className="stat">
          <div className="k">Campanha total</div>
          <div className="v">{totalWins}-{totalLosses}</div>
        </div>
        <div className="stat">
          <div className="k">Aproveitamento</div>
          <div className="v">
            {totalWins + totalLosses
              ? `${Math.round((totalWins / (totalWins + totalLosses)) * 100)}%`
              : '-'}
          </div>
        </div>
      </div>

      <h2>Sala de trofeus</h2>
      <div className="grid two">
        {TROPHIES.map((t) => {
          const n = counts[t.id] || 0;
          return (
            <div key={t.id} className="card center" style={{ margin: 0, opacity: n ? 1 : .55 }}>
              <Trophy kind={t.id} size={62} dim={!n} />
              <div style={{ fontWeight: 700, fontSize: 13, marginTop: 4 }}>{t.name}</div>
              <div className="small dim">{n ? `${n}x` : t.hint}</div>
            </div>
          );
        })}
      </div>

      <h2>Premios individuais</h2>
      {(() => {
        // Junta os premios de todas as temporadas: quantos cada atleta ganhou.
        const porPremio = {};
        for (const h of history) {
          if (!h.awards) continue;
          for (const chave of AWARD_ORDER) {
            const a = h.awards[chave];
            if (!a?.vencedor) continue;
            porPremio[chave] ||= { nome: a.nome, unidade: a.unidade, linhas: [] };
            porPremio[chave].linhas.push({ ...a.vencedor, season: h.season });
          }
        }
        const chaves = AWARD_ORDER.filter((k) => porPremio[k]);
        if (!chaves.length) {
          return (
            <div className="card dim small">
              Os premios da temporada aparecem aqui quando ela terminar: MVP,
              cestinha, rei do 3, rei do garrafao, melhor defensor, novato e
              sexto homem.
            </div>
          );
        }
        return chaves.map((k) => {
          const bloco = porPremio[k];
          const meus = bloco.linhas.filter((l) => l.teamId === state.clubId).length;
          return (
            <div key={k} className="card tight">
              <div className="row spread" style={{ marginBottom: 6 }}>
                <h3 style={{ margin: 0 }}>{bloco.nome}</h3>
                {meus > 0 && <span className="pill on">{meus} do seu elenco</span>}
              </div>
              {bloco.linhas.slice().reverse().slice(0, 6).map((l) => (
                <div key={`${k}-${l.season}`} className="row spread" style={{ padding: '5px 0' }}>
                  <span className={l.teamId === state.clubId ? 'acc' : ''}>
                    <b>{l.name}</b>
                    <span className="dim small"> · {l.teamName}</span>
                  </span>
                  <span className="dim small tabular">
                    {l.valor} {bloco.unidade} · T{l.season}
                  </span>
                </div>
              ))}
            </div>
          );
        });
      })()}

      <h2>Historico</h2>
      {!history.length ? (
        <div className="card dim small">
          Nenhuma temporada fechada ainda. O historico aparece aqui quando a
          primeira acabar.
        </div>
      ) : (
        [...history].reverse().map((h) => {
          const meta = TROPHIES.find((t) => t.id === h.trophy);
          const foiCampeao = h.champion === state.clubId;
          return (
            <div key={h.season} className={`pick ${foiCampeao ? 'me' : ''}`}>
              <div className="row spread">
                <div className="row" style={{ gap: 10, minWidth: 0 }}>
                  {h.trophy
                    ? <Trophy kind={h.trophy} size={30} />
                    : <span style={{ width: 30, textAlign: 'center', color: 'var(--dim)' }}>—</span>}
                  <div style={{ minWidth: 0 }}>
                    <div className="n">
                      Temporada {h.season}
                      {' · '}
                      <span className={foiCampeao ? 'gold' : ''}>
                        {h.userRecord?.wins}-{h.userRecord?.losses}
                      </span>
                    </div>
                    <div className="small dim">
                      {h.fired ? 'Demitido' : h.unemployedSeason ? 'Sem clube' : meta ? meta.name : 'Sem playoffs'}
                      {' · campeao: '}
                      {h.championName || '-'}
                      {h.leader && ` · cestinha: ${h.leader.name} (${h.leader.avg})`}
                    </div>
                  </div>
                </div>
              </div>
              {/* Uma temporada fechada e a unica coisa do jogo que vale um
                  link: ela tem campanha, trofeu e cestinha, ou seja, uma
                  historia com comeco e fim. */}
              <CompartilharTemporada state={state} registro={h} className="pick-share" />
            </div>
          );
        })
      )}

      {history.length > 0 && (
        <>
          <h2>Campeoes da liga</h2>
          <div className="card tight">
            {[...history].reverse().map((h) => (
              <div key={h.season} className="row spread" style={{ padding: '7px 0' }}>
                <span className="dim small">Temporada {h.season}</span>
                <span className="row" style={{ gap: 8 }}>
                  {h.champion && <Crest team={teamById(state, h.champion) || { name: h.championName }} size={20} />}
                  <b className={h.champion === state.clubId ? 'gold' : ''}>{h.championName || '-'}</b>
                </span>
              </div>
            ))}
          </div>
        </>
      )}
      <div style={{ height: 26 }} />
    </>
  );
}
